import { AUTO_ADVANCE_QUESTION_TYPES } from "@/modules/session-survey/consts/autoAdvanceQuestionTypes";
import { SurveyQuestion } from "@/modules/session-survey/types/SurveyQuestion";

export const isAutoAdvanceQuestionType = (type: string) =>
  AUTO_ADVANCE_QUESTION_TYPES.has(type);

export const isAutoAdvanceQuestion = (question: SurveyQuestion) =>
  isAutoAdvanceQuestionType(question.type) && Boolean(question.options?.length);
